import type { NavigationError, Router } from '@angular/router';
import { RedirectCommand } from '@angular/router';

const NO_MATCH_ERROR_CODE = 4002;

export function handleNavigationError(
    navigationError: NavigationError,
    router: Pick<Router, 'parseUrl'>
): RedirectCommand {
    const error: unknown = navigationError.error;

    if (!(error instanceof Error && 'code' in error && error.code === NO_MATCH_ERROR_CODE)) {
        throw error;
    }

    return new RedirectCommand(router.parseUrl('/404'));
}
